module.exports = __webpack_public_path__ + "4852482a493cf53c8e3851d498e42a3f.svg";